<template>
  <div>
    <el-dialog
      class="dialog-treaty"
      title="《课时包服务协议》"
      :visible="visible"
      @close="onCancel"
      append-to-body
      width="800px"
    >
      <div class="">
        <!--        <div class="title">《课时包服务协议》</div>-->
        <el-scrollbar ref="scroll" class="content">
          <Rich id="treaty-content" v-html="treatyContent"></Rich>
        </el-scrollbar>
      </div>
      <template v-slot:footer>
        <el-button @click="onCancel">不同意</el-button>
        <el-button type="primary" @click="onConfirm">同意</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PackageService',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    treatyContent: {
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal(value) {
      this.visible = value;
      if (value) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    },
  },
  methods: {
    onCancel() {
      this.visible = false;
      this.$emit('update:showModal', false);
    },
    onConfirm() {
      this.onCancel();
      this.$emit('onConfirm');
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-treaty {
  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog__body {
    padding: 24px 24px 0 24px;
    height: 500px !important;
    max-height: none;
  }
  .content {
    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 24px;
      margin-bottom: 16px;
    }
    ::v-deep {
      .el-scrollbar__wrap {
        //border-radius: 5px;
        overflow-x: hidden;
      }
    }
    //#treaty-content {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    & {
      -ms-overflow-style: none;
    }
    & {
      overflow: -moz-scrollbars-none;
    }
    //}
  }
  ::v-deep .el-dialog__footer {
    padding: 24px;
  }
}
</style>
